import { PageMeta } from "@/components/common/Seo/PageMeta"
import IntegrationsPage from "@/components/marketing/products/integrations/IntegrationsPage"
import { ProductSchema } from "@/components/products/ProductSchema"

const index = () => (
  <>
    <ProductSchema id="integrations" />
    <PageMeta
      meta={{
        title: "Integrations for exchanges and media",
        description:
          "Embed Token Terminal's standardized crypto metrics in your exchange, research or media platform. Our data reaches 250+ million users daily. Contact us today.",
      }}
    />
    <IntegrationsPage />
  </>
)

export default index
